module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/logo_suns_white-3cb810111201399aa1b84a73f0eddc6a.svg";